<template>
	<div class="project-report-email-popup">

		<div class="project-report-email-dialog" data-aos="fade-up" data-aos-anchor-placement="center-bottom" data-aos-duration="400">
			<img src="@/drc/assets/icons/x_white.svg" @click="closeDialog" alt="close-icon">
			<div class="error-report-container">
				<h3>{{ $t('notifications.reportAProblem') }}</h3>
				<span>{{$t('notifications.reportAProblemDescription')}}</span>

				<CommonSelect
					:form-data="formData"
					field="topic"
					:label="$t('notifications.topic')"
					:placeholder="$t('notifications.topicPlaceholder')"
					:options="dropdownData.topics"
					text-field-name="name"
					:errorLabel="$t('submissionForm.noYearFound')"
					:isMultiple="false"
				/>

				<div class="textarea-container">
					<label>{{$t('notifications.description')}}</label>
					<textarea class="project-report-text-area"
            :placeholder="$t('notifications.descriptionPlaceholder')"
            res
            v-model="formData.description.value"/>
				</div>

				<CommonImageUpload
					:label="$t('notifications.screenshotOptional') "
					:upload-text="$t('submissionForm.clientLogoUploadText')"
					:form-data="formData"
					field="image"/>

				<div v-if="formSubmittedEmpty" class="form-empty-warning">{{$t('notifications.formEmptyWarning')}}</div>
				<div class="buttons-container">
					<button class="cancel-button button" @click="closeDialog">
						{{ $t('common.cancel') }}
					</button>
					<button :disabled="sending"
									class="report-problem-button button"
									:class="sending ? 'sending' : ''"
									@click="handleMessage">
						<img src="@/drc/assets/images/loading_dark.png" v-if="sending" alt="send-icon">
						{{ sending ? $t('notifications.reportAProblemSending') : $t('notifications.reportAProblemSend') }}
					</button>
				</div>
			</div>
		</div>

		<div @click="closeDialog"></div>
	</div>
</template>
<script>
import CommonSelect from "@/drc/pages/submit-form/components/CommonSelect.vue";
import CommonImageUpload from "@/drc/pages/submit-form/components/CommonImageUpload.vue";

export default {
	name: "ReportAProblem",
	components: {CommonImageUpload, CommonSelect},
	props: [ "title", "sending" ],
	data() {
		return {
			formSubmittedEmpty: false,
			isTextAreaInFocus: false,
			userMessage: "",
			doShowInputErrorMessage: false,
			formData: {
				topic: {
					ref: null,
					value: [],
					errors: [],
					validations: []
				},
				description:{
					value: ''
				},
				image: {
					ref: null,
					value: null,
					errors: [],
					validations: [
						{
							type: 'validateFileType',
							allowedTypes: ['image/png', 'image/jpeg', 'image/webp'],
							message: 'submissionForm.validateFileType',
						},
						{
							type: 'validateFileSize',
							maxFileSize: 5000000,
							message: 'submissionForm.validateFileSize',
						}
					]
				}
			},
			dropdownData:{
				topics:[
					{
						name: "Bug",
						value: "bug"
					},
					{
						name: "Incorrect Information",
						value: "incorrectInformation"
					},
					{
						name: "Other",
						value: "other"
					}
				],
			},
		}
	},
	methods: {
		closeDialog() {
			this.$emit('closeDialog');
		},
		handleMessage() {
			if(this.formData.topic.value.length === 0 || this.formData.description.value.trim() === ''){
				this.formSubmittedEmpty = true;
			}else{
				this.formSubmittedEmpty = false;
				this.$emit('handleMessage', this.formData);
			}

		},
	}
}
</script>
<style lang="scss">
.project-report-email-popup {
	text-align: left;
	.project-report-email-dialog div div.generic-select {
		margin-top: 16px;
		margin-bottom: 16px;
		.label-holder label{
			color: #001f33 !important;
		}
		.dropdown-container .dropdown-activator{
			border: 1px solid #E5E5EA !important;
		}
	}
	.project-report-email-dialog div div.image-upload-container {
		div.image-uploader label.uploader-section{
			background: #F2F2F7 !important;
		}
		div.hint label{
			color: #001f33 !important;
		}
	}


}
</style>
<style lang="scss" scoped>
@import "@/common/assets/css/_variables.scss";

.project-report-email-popup {
	width: 100%;
	position: fixed;
	top: 0;
	left: 0;
	z-index: calc(#{30} - 2); // (x-2), because (x-1) is the z-index for sidebar background
	display: flex;
	justify-content: center;

	.textarea-container{
		label{
			font-family: Roboto;
			font-weight: 600;
			font-size: 17px;
			line-height: 22px;
			letter-spacing: 0px;
			color: #001F33;
		}
		textarea{
			font-family: Roboto;
			font-weight: 400;
			font-size: 16px;
			line-height: 21px;
			letter-spacing: 0px;
			background: #FFFFFF;
			height: 106px;
			padding: 16px;
			border: 1px solid #E5E5EA;
			border-radius: 0px;
			color: black;
			margin-top:8px;
			resize: none;
		}
	}

	& > div:nth-child(2) {
		height: 100vh;
		width: 100vw;
		background-color: rgba(0, 0, 0, 0.5);
		position: absolute;
		top: 0;
		left: 0;
		z-index: -1;
		cursor: pointer;
	}
}

.project-report-email-dialog {
	max-width: 688px;
	margin: 10vh 5px 0 5px;
	background-color: white;
	position: relative;
	width: 90%;
	cursor: default;
	max-height: 90vh;
	overflow-y: auto;

	@media (max-width: 768px) {
		margin-top: 80px
	}

	.error-report-container{
		.form-empty-warning{
			color:red;
			text-align: right;
			margin-bottom: -25px;
		}
		.buttons-container{
			display: flex;
      justify-content: space-between;
      margin-top: 32px;
			gap: 12px;
			margin-bottom: 32px;
			.button {
				border-radius: 4px;
        background: #FFFFFF;
				width: 100%;
				height: 54px;
				border: none;
				font-family: Roboto;
				font-weight: 400;
				font-size: 17px;
				line-height: 22px;
				letter-spacing: 0px;
				text-align: center;
				border: 1px solid #E5E5EA;
				cursor: pointer;
				&.report-problem-button {
					background: #ffb81c;
				}
			}
		}
	}

	& > img {
		position: absolute;
		top: 5px;
		right: 5px;
		height: 18px;
		width: 18px;
		margin: 23px 23px 0 0;
		cursor: pointer;
	}

	& > div {
		margin: 0 64px;

		@media screen and (max-width: 768px) {
			margin: 0 40px;
		}
		@media screen and (max-width: 375px) {
			margin: 0 20px;
		}
	}

	& > div > h3 {
		font-family: Tiempos Headline;
		font-weight: 600;
		font-size: 28px;
		line-height: 34px;
		letter-spacing: 0.36px;
		color: #001F33;
	}

	& > div > span {
		font-family: Roboto;
		font-weight: 400;
		font-size: 17px;
		line-height: 22px;
		letter-spacing: 0px;
		color: #636366;

	}
}

.report-problem-button {
	&.sending {
		background: #F3D592;
	}

	&:disabled {
		cursor: not-allowed;
	}

	img {
		margin-bottom: 2px;
		width: 20px;
		animation: rotateLoading 3s linear infinite;
	}
}

.project-report-text-area {
	min-height: 172px;
	width: 100%;
	margin-top: 32px;
	padding: 23px;
	background-color: #232526;
	color: #BABABA;
	font-size: 16px;
	font-weight: 300;
	line-height: 18px;
	border-width: 0;
	border-radius: 6px;

	&:focus-visible {
		outline-color: unset;
	}

	&:focus {
		outline: unset;
		border: 1px solid $color-secondary-light;
	}
}

@keyframes rotateLoading {
	0% {
		transform: rotate(0deg);
	}

	100% {
		transform: rotate(360deg);
	}
}
</style>
